import { Box } from "@mui/system";
import { Link, LinkProps } from "react-router-dom";

const AppRouterLink = (props: LinkProps) => <Box component="span" sx={{'& a': {color: "primary.main"}}}><Link {...props}></Link></Box>
export default AppRouterLink;